import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e9eaeb;
  border-radius: 12px;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  background: #fff;
  width: 100%;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #ffffff;
  border-bottom: 1px solid #e9eaeb;

  a {
    font-family: "Geist", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: #535862;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
    &:active {
      opacity: 0.6;
    }
  }
`;

export const CardTitle = styled.h3`
  font-family: "Geist", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #181d27;
  margin: 0;
`;

export const CardContent = styled.div`
  background: #fff;
  padding: 0;
`;

export const ShowMoreButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #535862;

  &:hover:not(:disabled) {
    opacity: 0.8;
  }
  &:active:not(:disabled) {
    opacity: 0.6;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: transparent;
    border: none !important;
  }
`;

// --- Table Cells ---
export const AssetCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AssetLogo = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`;

export const AssetInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100px;
`;

export const AssetSymbol = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #101828;
`;

// --- Figma pill style for Buy/Sell ---
export const AssetTag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 9px;
  gap: 3px;

  border-radius: 6px;
  border: 1px solid
    ${(props) =>
      props.$type === "Buy"
        ? "#B7E2C3"
        : props.$type === "Sell"
        ? "#F2C0BC"
        : "#d5d7da"};
  background: ${(props) =>
    props.$type === "Buy"
      ? "#E6F6EC"
      : props.$type === "Sell"
      ? "#FBEAE9"
      : "#fff"};
  color: ${(props) =>
    props.$type === "Buy"
      ? "#2D8C44"
      : props.$type === "Sell"
      ? "#C14A41"
      : "#414651"};

  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const ExecutionCell = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PriceValue = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #101828;
`;

export const SharesValue = styled.div`
  font-size: 12px;
  color: #667085;
`;

export const TotalCell = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: ${(props) => (props.$isPositive ? "#2D8C44" : "#C14A41")};
`;

export const DateCell = styled.div`
  font-size: 14px;
  color: #101828;
`;
